export const CART_FETCHING = 'CART_FETCHING'
export const CART_SUCCESS = 'CART_SUCCESS '
export const CART_FAILURE = 'CART_FAILURE'

export const TOTAL_CART_SUCCESS = 'TOTAL_CART_SUCCESS'
